import React from 'react'
import { Container } from 'shared/ui/container/Container'
import { Card } from 'shared/ui/card/Card'
import { FormGroup } from 'shared/form'
import { FormSelect } from 'shared/form/FormSelect'

import classes from './AddServiceToClient.module.scss'
import { Button } from 'shared/ui/button/Button'
import { useState } from 'react'
import { toFormData } from 'shared/util/form-data'
import { useClients } from 'shared/hooks/data/client'

interface Modal {
  close?: () => void
  service: Model.Service
}

export const AddServiceToClient: React.FC<Modal> = ({ close, service }) => {
  const clients = useClients()
  const [client_id, setClientId] = useState<string>()

  const save = (event: React.FormEvent) => {
    event.preventDefault()

    if (service && client_id) {
      let body = toFormData({
        name: service?.name || '',
        host_prize: service?.host_prize || 12,
        price: service?.price || 0,
        products: service?.products || [],
        client: { id: client_id }
      })

      const init: RequestInit = {
        method: 'POST',
        body
      }

      fetch('/api/services', init).then(() => window.location.reload())
    }
  }

  return (
    <Container className={classes.container}>
      <Card>
        <h1>Copiar para cliente</h1>
        <form onSubmit={save}>
          <FormGroup label="Escolha o cliente">
            <FormSelect onChange={setClientId} required>
              <option>Selecione</option>
              {clients?.map((city, index) => (
                <option key={index} value={city.id}>
                  {city.name}
                </option>
              ))}
            </FormSelect>
          </FormGroup>
          <div className={classes.row}>
            <Button outline onClick={close}>
              Cancelar
            </Button>
            <Button type="submit">Adicionar</Button>
          </div>
        </form>
      </Card>
    </Container>
  )
}
